import { env } from '@/env';

export interface IBatchImportTemplate {
  images: {
    emptyState: string;
  };
}

const SonarBatchImport: IBatchImportTemplate = {
  images: {
    emptyState: `${env.VITE_CDN_URL}/Sonarprint/empty-state-device-key-import.svg`,
  },
};

export { SonarBatchImport };
